export const nodemailerUrl = "https://mailer.pushkeen.ru/api/sendemail";
export const nodemailerUrlBrief = "https://mailer.pushkeen.ru/api/brief";

// export const nodemailerUrl = "http://localhost:5051/api/sendemail";
// export const nodemailerUrlBrief = "http://localhost:5051/api/brief";